// src/features/owner/sections/content/ReportsSection.tsx — read mirror of the Council report queue.
import { useOwnerModeration } from '@/hooks';
import { OwnerPanel, DataTable } from '../../components';
import type { Column } from '../../components';

type QueueRow = { id: string; category: string; status: string; kind: string };

export function ReportsSection() {
  const { data, loading, error } = useOwnerModeration();

  const columns: Column<QueueRow>[] = [
    { key: 'id', header: 'Case', render: (r) => r.id },
    { key: 'category', header: 'Category', sortBy: (r) => r.category, render: (r) => r.category },
    { key: 'kind', header: 'Kind', render: (r) => r.kind },
    { key: 'status', header: 'Status', render: (r) => r.status },
  ];

  if (loading) return <p style={{ opacity: 0.6 }}>Loading…</p>;

  return (
    <OwnerPanel title="Report queue (Council oversight)">
      <DataTable<QueueRow>
        columns={columns}
        rows={data?.queue ?? []}
        rowKey={(r) => r.id}
        emptyIcon="flag"
        emptyMessage={error ?? 'No open reports'}
      />
    </OwnerPanel>
  );
}
